<div class="container-fluid page">
    <div class="d-flex page__box p-3 mt-2"><img src="./assets/arrow_logo.png" class="arrow"
            (click)="listPage()">&nbsp;&nbsp;Post a New Question</div>
    <div class="example-header">
        <mat-card class="matCardForm matcard">
            <mat-card-content class="pa-1 matcard" style="width: auto !important;">
                <!-- <form [formGroup]="askquestionform" (ngSubmit)="onSubmit1()"> -->
                <form [formGroup]="askquestionform">
                    <div class="fulllwidth">

                        <mat-form-field>
                            <!-- <input style="width: 938px;" type="text" formControlName="questionTitle" 
                                maxlength="80" required matInput placeholder="Enter title here"><br> -->
                                <input style="width: 938px;" type="text" formControlName="questionTitle" 
                                 required matInput placeholder="Enter title here"><br>
                        </mat-form-field>
                        <div *ngIf="askquestionform.controls['questionTitle'].invalid && (askquestionform.controls['questionTitle'].dirty || askquestionform.controls['questionTitle'].touched)">
                        <div *ngIf="questionTitle.errors.minlength" style="width: fit-content; color: red;">
                            Enter Title must be at least 20 characters long.
                       </div>
                       <div *ngIf="questionTitle.errors.maxlength" style="width: fit-content;color: red;">
                        Enter Title  maximum 60 characters long.
                   </div>
                </div>
                        <br>

                        <p style="text-align: left;padding-left: 4px;"><b>Post the question or topic with all the
                                necessary details.</b>&nbsp;&nbsp;<b class="guidelineClass"
                                (click)="guidelinePage()">Read our community guidelines.</b></p>
                        <textarea id="w3review" formControlName="Answer"
                            placeholder="Enter your question here, max 400 characters." style="width:100%"
                            formControlName="quetionDiscription" name="w3review" rows="10" cols="120"
                          ></textarea>
                            <div *ngIf="askquestionform.controls['quetionDiscription'].invalid && (askquestionform.controls['quetionDiscription'].dirty || askquestionform.controls['quetionDiscription'].touched)">
                                <div *ngIf="quetionDiscription.errors.maxlength" style="width: fit-content; color: red;">
                                    Enter quetion discription must be maximum 400 characters long*.
                               </div>
                               </div>

                        <div class="row">
                            <div class="col-12" style="margin-bottom: 10px;">
                                <div class="col-12">
                                    <p class="pull-left" style="    width: 100%;
                                text-align: start;">Attach a reference document: An image, file less than 5 MB (PNG,
                                        JPEG/JPG)</p>
                                </div>
                                <div class="col-12">
                                    <input class="col-6 pull-left" formControlName="Image"
                                        (change)="processImage1($event)" type="file" accept="video/mp4,video/x-m4v,video,image/png, image/gif, image/jpeg/*" #inputFile />
                                        <!-- accept="image/png, image/gif, image/jpeg"  -->
                                    <button class="col-1 pull-left" (click)="removeFile()" *ngIf="isButtonVisible"
                                        matTooltip="remove attachment" style="border: none;" mat-stroked-button
                                        aria-label="remove file">
                                        <mat-icon [ngStyle]="{'color':'red'}">clear</mat-icon>
                                    </button>
                                </div>
                            </div>
                                <div class="col-md-8">
                                </div>
                                <div class="col-md-4">
                                    <button style='margin-right:16px'class="pull-right submitBtn" mat-button
                                    (click)="listPage()"[disable]="disable">Cancel</button>

                                     <button style='margin-right:16px' class="pull-right submitBtn" mat-button type="submit"
                                        (click)="onSubmit1()" [disable]="disable">Publish</button>
                                </div>

                        </div>

                    </div>

                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>